import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private langSource = new BehaviorSubject<string>('en'); // Default language
  currentLang$ = this.langSource.asObservable();

  setLanguage(lang: string) {
    this.langSource.next(lang);
  }

  getLanguage(): string {
    return this.langSource.getValue();
  }
}
